import { bbsApi } from 'yxt-biz-pc/packages/api';

// https://api-phx-di-hw.yunxuetang.com.cn/bbs/doc.html#/default/%E8%AE%A8%E8%AE%BA%E5%8C%BA%E4%BB%BB%E5%8A%A1/adminDiscussDetail
export const getDiscussDetail = (params, isAdmin) => {
  return bbsApi.post(
    isAdmin
      ? `/bbseng/admin/discuss/detail/${params.boardId}`
      : `/bbseng/stu/discuss/detail/${params.boardId}`,
    params,
    {
      params: isAdmin ? { userId: params.userId } : {}
    }
  );
};
